import { render, staticRenderFns } from "./HrPerfPromise.vue?vue&type=template&id=3942f22c&scoped=true&"
import script from "./HrPerfPromise.vue?vue&type=script&lang=js&"
export * from "./HrPerfPromise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3942f22c",
  null
  
)

export default component.exports